const listesText = {
  listesTitle: "Les listes",
};

export default listesText;
